// extracted by mini-css-extract-plugin
export var externalLink = "_ap-0";
export var internalLinkLabel = "_ap-1";